import { ModifierTypeMap } from '../../Prototype/Level/Card/ModifierTypeMap';
import { ICardModifierData } from '../../Prototype/Level/Card/ICardModifierData';
import { ICardsState } from './ICardState';
import { IGameState } from '../Game/IGameState';
import CardStateHelper from './CardStateHelper';

export default class CardStateModifierHelper {
    public static playModifier(
        state: IGameState,
        modifier: ICardModifierData,
        cardID: string
    ): IGameState {
        const modBehavior = CardStateModifierHelper.getModifierBehavior(
            state.levelState.cardsState,
            modifier,
            cardID
        );

        state = modBehavior.play(state);

        const cardsState = modBehavior.updateModifier(state.levelState.cardsState, cardID, {
            properties: {
                ...modifier.properties,
                plays: modifier.properties.plays + 1,
            },
        });

        return CardStateHelper.updateGameState(state, cardsState);
    }

    public static getModifierBehavior(
        state: ICardsState,
        modifier: ICardModifierData,
        cardID: string
    ) {
        return new ModifierTypeMap[modifier.type].behavior(modifier, cardID);
    }

    /**
     * Trigger an 'update' for all modifiers in play.
     * @param state
     * @param sourceCardID
     * @param isCardFold Special case update for modifiers that are updating via a card-fold action (fog).
     */
    public static updateModifiers(
        state: IGameState,
        sourceCardID: string,
        isCardFold: boolean = false
    ): IGameState {
        let cardsState = CardStateHelper.getCardsState(state);
        // Call update() for each modifier.
        const allCards = [
            ...cardsState.inPlay,
            ...cardsState.inStack,
            ...cardsState.folded,
            ...cardsState.discarded,
        ];

        allCards.forEach(cardID => {
            cardsState.cards[cardID].modifiers.forEach(
                (modifier: ICardModifierData) => {
                    const modBehavior = CardStateModifierHelper.getModifierBehavior(
                        cardsState,
                        modifier,
                        cardID
                    );

                    if (isCardFold) {
                        state = modBehavior.onCardFolded(state, sourceCardID);
                    } else {
                        state = modBehavior.onCardMatched(state, sourceCardID);
                    }
                    cardsState = CardStateHelper.getCardsState(state);
                }
            );
        });

        // Call lateUpdate() for each modifier.
        allCards.forEach(cardID => {
            cardsState.cards[cardID].modifiers.forEach(
                (modifier: ICardModifierData) => {
                    const modBehavior = CardStateModifierHelper.getModifierBehavior(
                        cardsState,
                        modifier,
                        cardID
                    );
                    cardsState = modBehavior.onCardMatchedLate(cardsState);
                }
            );
        });
        return CardStateHelper.updateGameState(state, cardsState);
    }

    public static onCardPlayed(
        state: ICardsState,
        cardID: string
    ): ICardsState {
        state.cards[cardID].modifiers.forEach(modifier => {
            state = CardStateModifierHelper.getModifierBehavior(
                state,
                modifier,
                cardID
            ).onOwnCardPlayed(state);
        });

        return state;
    }

    public static onCardDiscarded(
        state: ICardsState,
        cardID: string
    ): ICardsState {
        state.cards[cardID].modifiers.forEach(modifier => {
            state = CardStateModifierHelper.getModifierBehavior(
                state,
                modifier,
                cardID
            ).onOwnCardDiscarded(state);
        });

        return state;
    }
}
